import { useState } from "react";

import useService from "../../../../hooks/useService";

export const useFetchFilterOpts = () => {
  const enumRepository = useService("repositories/enum-repository");

  const [showMoreVisible, setShowMoreVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function getOptions({
    apiUrl = "",
    limit = 100,
    orderingVal = "name",
    valueKey = "id",
    selectedItems = [],
    searchVal = "",
  }) {
    setIsLoading(true);
    try {
      const queryInitializer = String(apiUrl).endsWith("?") ? "" : "?";
      const response = await enumRepository.query({
        urlPath: `${apiUrl}${queryInitializer}limit=${limit}&ordering=${orderingVal ?? "name"}${!searchVal ? "" : `&search=${searchVal}`}`,
      });
      const count = await enumRepository.getTotalCount();

      // If we're searching for selected items and haven't found them all yet
      if (selectedItems && selectedItems.length > 0) {
        const foundSelectedItems = response.filter((option) =>
          selectedItems.includes(String(option[valueKey]))
        );

        // If we haven't found all selected items and there are more records to fetch
        if (foundSelectedItems.length < selectedItems.length && limit < count) {
          // Recursively call with increased limit
          // Increade limit by 1000 to reduce number of requests
          const newLimit = Math.min(limit + 1000, count);
          return await getOptions({
            apiUrl,
            orderingVal,
            valueKey,
            selectedItems,
            searchVal,
            limit: newLimit,
          });
        }
      }
      const allowShowMore = count > limit;
      setShowMoreVisible(allowShowMore);
      setOptions(response);
      return response;
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }

  return {
    getOptions,
    isLoading,
    options,
    showMoreVisible,
  };
};
